module.exports = __webpack_public_path__ + "img/img11.96c012c6.svg";